import React, { useEffect, useState } from "react";
import { TreeSelect, ConfigProvider } from "antd";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

const { SHOW_PARENT } = TreeSelect;

function AntDTree(props) {

  const [value, setValue] = useState([]);
  const [allState, setAllllState] = useState(
    props.treeData
      ? props.treeData.map((data) => {
          return data.value;
        })
      : []
  );

  const onChange = (valuee, label, extra) => {
    if (extra.triggerValue === "all") {
      if (extra.checked) {
        setValue(["all", ...allState]);
      } else {
        setValue([]);
      }
      return;
    } else {
      let isAll = valuee.includes("all");
      //   let finalValue:any = Array.from(new Set([...valuee, ...value]));
      if (isAll) {
        setValue(
          valuee.filter((val) => {
            return val !== "all";
          })
        );
      } else {
        if (IsSameArrays(valuee, allState)) {
          setValue(["all", ...valuee]);
        } else {
          setValue(valuee);
        }
      }
    }
  };

  const IsSameArrays = (array1, array2) => {
    const array2Sorted = array2.slice().sort();
    return (
      array1.length === array2.length &&
      array1
        .slice()
        .sort()
        .every(function (value, index) {
          return value === array2Sorted[index];
        })
    );
  };

  useEffect(() => {
    props.getTreeValues(value);
  }, [value]);

  useEffect(() => {
    setValue(props.initialValues);
  }, [props.initialValues]);



  const tProps = {
    treeData: [
      {
        title: "all",
        value: "all",
        key: "all",
      },
      ...props.treeData,
    ],
    value: value,
    onChange: onChange,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: props.placeholder,
    className: value.length ? "" : "antTreeSelectError",
    allowClear:true,
    style: {
      width: "100%",
      minHeight:"55px",
      margin: "0% 3% 2% 0%",
    },
    listHeight: 1000,
    treeLine: true,
    disabled: props.disabled,
    // open:true
    // maxTagCount: 3,
    // maxTagPlaceholder: "+"+ (value.length - 3) + " more",
    // treeDefaultExpandAll:true
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          TreeSelect: {
            colorPrimary: "#0e3f51",
            colorPrimaryHover: "#0e3f51",

            /* here is your component tokens */
          },
        },
      }}
    >
      <TreeSelect
        {...tProps}
        // open
        treeNodeFilterProp="title"

      />
    </ConfigProvider>
  );
}

export default AntDTree;
